import React from 'react';

import { ChatRoleEnum } from '@/types/chat';

import styles from './chatbubble.module.scss';


export type ChatBubbleProps = {
  children: React.ReactNode;
  type: ChatRoleEnum;
};

export default function ChatBubble( props: ChatBubbleProps ) {
  const {
    children,
    type
  } = props;

  const className = type == ChatRoleEnum.USER ? styles.chatbubble : styles.chatbubble_assistant;
  const wrapperClassname = type == ChatRoleEnum.USER ? styles.wrapper : styles.wrapper_assistant;

  return (
    <div className={ wrapperClassname }>
      <div className={ className }>
        { children }
      </div>
    </div>
  );
}